import classNames from 'classnames';
import { IncidentTypePriority } from 'compliance-api';

interface IncidentTypePriorityLabelProps {
  priority: IncidentTypePriority;
}

const IncidentTypePriorityLabel = ({ priority }: IncidentTypePriorityLabelProps) => {
  return (
    <div className="flex gap-3 items-center">
      <span
        className={classNames('w-3 h-3 rounded-sm', {
          'bg-green-600': priority === IncidentTypePriority.Normal,
          'bg-orange-500': priority === IncidentTypePriority.High,
          'bg-red-600': priority === IncidentTypePriority.Critical,
        })}
      />
      <span className="capitalize">{priority}</span>
    </div>
  );
};

export default IncidentTypePriorityLabel;
